import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    border-radius: 6px;
    padding: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;


    .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 15px;
        margin-bottom: 10px;
        flex-wrap: wrap;

        .header-left {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 10px;
            flex: 1;
            min-width: 0;

            h2 {
                font-size: 14px;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                color: ${({ theme }) => theme.colors.interfaceText600 || '#374151'};
                margin: 0;
            }

            p {
                font-size: 12px;
                color: ${({ theme }) => theme.colors.interfaceGray400};
                background-color: rgba(0, 0, 100, 0.1);
                padding: 10px;
                border-radius: 10px;
                font-weight: 600;
            }
        }

        .filtro-origem {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;

            label {
                font-size: 12px;
                color: ${({ theme }) => theme.colors.interfaceGray600 || '#4B5563'};
                font-weight: 500;
                white-space: nowrap;
            }

            .select-origem {
                min-width: 200px;
            }
        }

        @media (max-width: 768px) {
            flex-direction: column;
            align-items: stretch;

            .header-left {
                flex-direction: column;
                align-items: flex-start;
            }

            .filtro-origem {
                width: 100%;

                .select-origem {
                    width: 100%;
                    min-width: unset;
                }
            }
        }
    }

    @media (max-width: 900px) {
        padding: 5px;
    }

    .skeleton-card {
        width: 100%;
        display: grid;
        grid-template-columns: 25px 1fr 25px;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
        gap: 5px;
        border-radius: 6px;
        padding: 15px;

        .skeleton-meio {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 8px;

            .skeleton-top {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 10px;
            }

            .skeleton-bottom {
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }
    }

    .lista-anexos {
        display: flex;
        flex-direction: column;
        container-type: inline-size;
        gap: 10px;
    }

    .lista-vazia {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        text-align: center;

        p {
            font-size: 14px;
            color: ${({ theme }) => theme.colors.interfaceGray500 || '#6B7280'};
            font-weight: 400;
        }
    }
`;